import { ReactElement } from 'react'

import { IconChevronRightSolid, IconExternalLinkThick } from '@swaggerhub-portal/component-library'

interface TopBarMenuLinkProps {
  icon: ReactElement<any>
  label: string
  href?: string
  isExternal?: boolean,
  isSubmenu?: boolean,
}

export const TopBarMenuLink = ({ icon, label, href, isExternal, isSubmenu = false }: TopBarMenuLinkProps) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={label} className="group">
    <div className="flex items-center h-[2.125rem] gap-2 px-4 text-body2 text-neutral-70 hover:bg-accent-10 hover:text-neutral-98 dark:bg-neutral-95 dark:hover:bg-neutral-90 dark:text-neutral-40 dark:hover:text-neutral-10 group-last:rounded-b group-first:rounded-t">
      <div className="flex justify-center flex-grow-0 flex-shrink-0 w-4">
        {icon}
      </div>
      {isSubmenu ?
        <>
          <div className="content-between">
            {label}
          </div>
          <div className="ml-auto">
            <IconChevronRightSolid width={8} height={8} />
          </div>
        </>
        :
        <div className="flex truncate">
          <div className="truncate">
            {label}
          </div>
          {isExternal ?
            <div>
              <IconExternalLinkThick />
            </div>
            : null}
        </div>
      }
    </div>
  </a>
)